if (!customElements.get('product-recommendations')) {
	customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.recommendation-list')) {
              this.classList.add('product-recommendations--loaded');
            } else {
              this.classList.add('hidden');
            }
            setTimeout(() => {
                const swiperEl = document.querySelector(".product-recommendations-slider");
            if (!swiperEl) return;

            new Swiper(swiperEl, {
              slidesPerView: 1.5,
              spaceBetween: 20,
              pagination: {
                el: swiperEl.querySelector(".swiper-pagination"),
                clickable: true,
              },
              navigation: {
                nextEl: swiperEl.querySelector(".swiper-button-next"),
                prevEl: swiperEl.querySelector(".swiper-button-prev"),
              },
              breakpoints: {     
                750: {
                  slidesPerView: 3,
                },
                990: {
                  slidesPerView: 4,
                },
              },
            });
            }, 1);
          })
          .catch(e => {
            console.error(e);
            this.classList.add('hidden');
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  });
}